/**
 * A match can have one of the following statuses
 * "proposed" - a match that has been assigned to the official but is awaiting them to
 * accept/decline it. This is the default status for a new match for integrations where the
 * partner supports this.
 * "accepted" - Official has accepted the proposed match. If the partner doesn't support
 * accept/decline from the user then this is the default status of an upcoming match
 * "declined" - Official declined the proposed match.
 * "cancelled" - The API partner has cancelled the game or removed the official from it
 * "postponed" - e.g. the referee postponed the match
 * "abandoned" - The match kicked off but aborted mid-match e.g. lightning strike)
 * "live" - the match is in progress and we have a live feed of match events from the watch
 * "finished" - the referee has marked the game as completed on the pitch, but hasn't
 * manually confirmed all match events are correct.
 * "confirmed" - the user has manually confirmed that all match data is accurate after the match.
 */
export enum MatchStatusExternal {
    /**
     * Proposed - a match that has been assigned to the official but is awaiting them to
     * accept/decline it. This is the default status for a new match for integrations where the
     * partner supports this.
     */
    proposed = "proposed",
    /**
     * Accepted - Official has accepted the proposed match. If the partner doesn't support
     * accept/decline from the user then this is the default status of an upcoming match
     */
    accepted = "accepted",
    /**
     * Declined - Official declined the proposed match.
     */
    declined = "declined",
    /**
     * Cancelled - The API partner has cancelled the game or removed the official from it
     */
    cancelled = "cancelled",
    /**
     * Postponed - e.g. the referee postponed the match
     */
    postponed = "postponed",
    /**
     * Abandoned - The match kicked off but aborted mid-match e.g. lightning strike)
     */
    abandoned = "abandoned",
    /**
     * Live - the match is in progress and we have a live feed of match events from the watch
     */
    live = "live",
    /**
     * Finished - the referee has marked the game as completed on the pitch, but hasn't
     * manually confirmed all match events are correct.
     */
    finished = "finished",
    /**
     * Confirmed - the user has manually confirmed that all match data is accurate after the match.
     */
    confirmed = "confirmed",
}
